import { Component, EventEmitter, Injectable, Input, Output } from '@angular/core';
import { MatPaginatorIntl, PageEvent, MatPaginator } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class AccountsPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  firstPageLabel = $localize`First page`;
  itemsPerPageLabel = $localize`Accounts per page:`;
  lastPageLabel = $localize`Last page`;

  nextPageLabel = 'Next page';
  previousPageLabel = 'Previous page';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return $localize`There are no accounts to display`;
    }
    const startIndex = (page * pageSize) + 1;
    const endIndex = Math.min(startIndex + pageSize - 1, length);
    return $localize`Showing ${startIndex} to ${endIndex} of ${length} accounts`;
  }
}

@Component({
    selector: 'pin-accounts-paginator',
    templateUrl: 'accounts-paginator.component.html',
    providers: [{ provide: MatPaginatorIntl, useClass: AccountsPaginatorIntl }],
    imports: [MatPaginator]
})
export class AccountsPaginatorComponent {
  @Input()
  pageSize: number;

  @Input()
  pageSizeOptions: number[];

  @Output()
  pageChange = new EventEmitter<PageEvent>();

  @Input()
  showFirstLastButtons: boolean;

  @Input()
  length: number;

  @Input('aria-label')
  ariaLabel: string;
}
